import fetch,{ postFrom } from '../utils/fetch';

// 获取项目list
export function getProjects() {
  return fetch({
      method: 'GET',
      url: 'basics/projects'
  })
}

// 查看基础规则
export function getBaseRule(projectFid) {
  return fetch({
      method: 'GET',
      url: 'baseRule/getBaseRule',
      params:{
        projectFid
      }
  })
}

// 保存基础规则
export function saveBaseRule(data) {
  return fetch({
      method: 'POST',
      url: 'baseRule/saveBaseRule',
      data
  })
}

// 服务费折扣规则详情 
export function getServiceFeeDiscountRule(projectFid) {
  return fetch({
      method: 'GET',
      url: 'serviceFeeDiscountRule/getServiceFeeDiscountRule',
      params: {
        projectFid
      }
  })
}

// 保存服务费折扣规则
export function saveServiceFeeDiscountRule(data) {
  return fetch({
      method: 'POST',
      url: 'serviceFeeDiscountRule/saveServiceFeeDiscountRule',
      data
  })
}

// 获取项目ZO列表
export function getZOlist(params) {
  return fetch({
      method: 'GET',
      url: 'baseRule/getZOlist',
      params
  })
}

//项目ZO列表查询条件 /baseRule/conditionForZOlist
export function conditionForZOlist() {
  return fetch({
      method: 'GET',
      url: 'baseRule/conditionForZOlist'
  })
}

//删除Zo
export function delZO(data) {
  return fetch({
      method: 'POST',
      url: 'baseRule/delZO',
      data
  })
}

// 获取ehr用户信息
export function getEHRUseInfo(userPhone) {
  return fetch({
      method: 'GET',
      url: 'baseRule/addEHRUserDetail',
      params: {
        userPhone
      }
  })
}

// 调用ehr获取用户信息
export function getEHRUserDetail(params) {
  return fetch({
    method: 'GET',
    url: 'baseRule/getEHRUserDetail',
    params
  })
}

// 添加ZO项目权限 /
export function addZO(data) {
  return fetch({
      method: 'POST',
      url: 'baseRule/addZO',
      data
  })
}

//修改ZO项目权限 baseRule/modifyZO
export function modifyZO(data) {
  return fetch({
      method: 'POST',
      url: 'baseRule/modifyZO',
      data
  })
}

// 特殊规则
export function getPageList(data) {
  return fetch({
      method: 'POST',
      url: 'specialRule/pageList',
      data
  })
}

// 根据手机号获取uid
export function getUid(userPhone) {
  return fetch({
      method: 'POST',
      url: 'specialRule/getUid',
      data: {
        userPhone
      }
  })
}

// 添加特殊规则

export function addSpecialRules(data) {
  return fetch({
      method: 'POST',
      url: 'specialRule/add',
      data
  })
}

// 关闭特殊规则

export function closeSpecialRules(fid) {
  return fetch({
      method: 'POST',
      url: 'specialRule/cancel',
      data:{
        fid
      }
  })
}
